import React from 'react';

const Settings = () => {
    return (
        <div>
            <h2>Settings</h2>
            <p>This is the settings page.</p>
        </div>
    );
};

export default Settings;
